import * as React from "react";
import "../../Styles/style.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { baseUrl } from "../../../api/ipconfig";
import { useEffect, useState } from "react";
import axios from "axios";
import UserDetails from "../../ads/userDetails";
import MyadsNavigation from "../../ads/myads-navigation";
import { AuthContext } from "../../../context/AuthContext";
import { Button } from "@mui/material";

const columns = [
  { id: "orderid", label: "Inspection Id", minWidth: 50 },
  {
    id: "carDetails",
    label: "Vehicle",
    minWidth: 70,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "address",
    label: "Address",
    minWidth: 140,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "inspectionSlot",
    label: "Inspection Slot",
    minWidth: 200,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "action",
    label: "Action",
    minWidth: 120,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
];

export default function MyOrders() {
  const { user } = React.useContext(AuthContext);
  const token = localStorage.getItem("token");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [inspectionOrders, setInspectionOrders] = useState(null);

  const fetchInspectionOrders = async () => {
    try {
      const response = await axios.get(`${baseUrl}/userinspectionrequest`, {
        params: {
          user_id: user?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setInspectionOrders(response?.data?.data);
    } catch (error) {
      console.error("Error fetching user posts:", error);
    }
  };
  useEffect(() => {
    if (user) {
      fetchInspectionOrders();
    }
  }, [user]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const ViewInspection = (inspectionToken) => {
    window.open(
      `https://www.inspectionreport.famewheels.com/inspection-report/${inspectionToken}`
    );
  };

  return (
    <>
      <div className="MyAds_main">
        <UserDetails />
        <div className="container-md MyAds_body">
          <div className="row pb-5">
            <div className="col-lg-2  p-0">
              <MyadsNavigation />
            </div>
            <div className="col-lg-10">
              <div className="ms-0 adsSection">
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer
                    className="inspectionOrders"
                    sx={{ minHeight: 440 }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                              className="bgSecondary color-white"
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {inspectionOrders &&
                          inspectionOrders
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((order, index) => (
                              <TableRow className="bg-light" key={index}>
                                <TableCell>{order?.inspection_id}</TableCell>
                                <TableCell>{`${order?.make_name} ${order?.model_name} ${order?.year_name}`}</TableCell>

                                <TableCell>
                                  {order?.address}
                                  {", "}
                                  {order?.city_name}
                                </TableCell>
                                <TableCell>{order?.inspection_slot}</TableCell>
                                <TableCell>
                                  {order?.iinitial_token && (
                                    <div className="col-lg-2 col-12 text-end  refundBtn">
                                      <Button
                                        variant="contained"
                                        onClick={() =>
                                          ViewInspection(order?.iinitial_token)
                                        }
                                        className=" bgSecondary color-white me-3"
                                      >
                                        View
                                      </Button>
                                    </div>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[30]}
                    component="div"
                    count={inspectionOrders && inspectionOrders.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    className="inspectionOrder_pagi"
                  />
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
